const imprint = {
  title: 'Imprint',
  intro:
    'gut geregelt is a Swiss software manufacturer and is part of the betascale group.',
  headquarter: 'Headquarters',
};

export default imprint;
